import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  reactive,
  onMounted,
  watch,
  PropType,
} from "vue";
import { post, get } from "@/api";
import { message } from "ant-design-vue";
import { VATransfer } from "./typings";


export default /*@__PURE__*/_defineComponent({
  __name: 'VAFormTransfer',
  props: {
  transfer: {
    type: Object as PropType<VATransfer>,
    required: true
  },
  visible: {
    type: Boolean
  }
},
  emits: ["update:visible", "on-success", "on-search"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const props = __props;
console.log(props, "propsprops--");

const data = reactive({
  dataSource: [],
  targetList: [],
  ID: props.transfer.ID
});
const onCancel = () => {
  emit("update:visible", false);
};
const submit = async () => {
  console.log(props.transfer, " props.transfer");

  const res = await post(props.transfer.url.update, {
    id: props.transfer.ID,
    [props.transfer.query]: data.targetList
  });
  if (res.data.code === 0) {
    emit("on-success");
    message.success(res.data.data);
  }
};
// 初始化执行一次
const getDataSource = async (search = "") => {
  //  左边
  const resAll = await get(
      props.transfer.url.dataSource,
      { all: true }
      // props.transfer.size ? { size: props.transfer.size } : { all: true }
  );
  if (resAll.data.code == 0) {
    data.dataSource = resAll.data.data.map(
        (element: { id: number; username: string; name_cn: string }) => {
          return {
            key: element[props.transfer.type],
            title: `${element.username}___${element.name_cn}`
          };
        }
    );
  }
};
// 点击每次执行
const getTargetList = async () => {
  //  已选中的 右边
  console.log(props.transfer, "props.transfer");

  const res = await get(props.transfer.url.targetList, {
    id: props.transfer.ID
  });
  console.log(res.data.data, "res.data.data");

  if (res.data.code == 0)
    data.targetList = res.data.data.map(
        (element: any) => element[props.transfer.type]
    );
};
const search = (direction: string, value: string) => {
  // console.log(value, "searchsearch");
  if (direction == "left") getDataSource(value);
};

watch(
    () => props.visible,
    (newValue: any) => {
      if (newValue) getTargetList();
    }
);
onMounted(() => {
  getDataSource();
});

return (_ctx: any,_cache: any) => {
  const _component_a_transfer = _resolveComponent("a-transfer")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    visible: __props.visible,
    maskClosable: false,
    onClose: onCancel,
    width: "800px",
    class: "custom-class",
    title: `关联角色租户-${props.transfer.title}`,
    placement: "right"
  }, {
    footer: _withCtx(() => [
      _renderSlot(_ctx.$slots, "action", {}, () => [
        _createVNode(_component_a_button, {
          style: {"margin-right":"8px"},
          size: "small",
          onClick: _withModifiers(onCancel, ["prevent"])
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Cancel")
          ])),
          _: 1
        }),
        _createVNode(_component_a_button, {
          type: "primary",
          size: "small",
          onClick: submit
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("提交")
          ])),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_transfer, {
        "target-keys": data.targetList,
        "onUpdate:targetKeys": _cache[0] || (_cache[0] = ($event: any) => ((data.targetList) = $event)),
        "data-source": data.dataSource,
        render: item => item.title,
        "show-search": props.transfer.showSearch?props.transfer.showSearch:true,
        pagination: props.transfer.pagination ? { pageSize:props.transfer.pageSize }:false,
        style: {"height":"100%"},
        onSearch: search
      }, null, 8, ["target-keys", "data-source", "render", "show-search", "pagination"])
    ]),
    _: 3
  }, 8, ["visible", "title"]))
}
}

})